import { render, staticRenderFns } from "./ListAdvertisement.vue?vue&type=template&id=408854f2&"
import script from "./ListAdvertisement.vue?vue&type=script&lang=js&"
export * from "./ListAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports